import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Col, Layout, Row, Table, message } from "antd";
import moment from "moment-timezone";
import numberFormat from "./../../utils/numberFormat";

import { sumBy } from "lodash";
import isEmpty from "../../validation/is-empty";

import classnames from "classnames";
import { useParams } from "react-router-dom";
import ReportHeading from "../../utils/ReportHeading";
import { edit, getDateTimeNow } from "../../utils/form_utilities";
import round from "../../utils/round";
import { addKeysToArray } from "../../utils/utilities";

const { Content } = Layout;

const transaction = "purchase-requests";
const url = `/api/${transaction}/`;
const title = "PURCHASE REQUEST";
const date_fields = ["date"];

const records_column = [
  {
    title: "Item",
    dataIndex: ["stock", "name"],
  },

  {
    title: "Qty",
    dataIndex: "quantity",
    align: "center",
    width: 80,
    render: (value, record) => (
      <span>{`${numberFormat(record.quantity)}`}</span>
    ),
  },

  {
    title: "UOM",
    dataIndex: ["stock", "unit_of_measure"],
    align: "center",
    width: 100,
  },
];

export default function PurchaseRequestPrintout({
  match,
  reprint = false,
  duplicate = false,
}) {
  const auth = useSelector((state) => state.auth);

  const initialValues = {
    _id: null,
    po_no: null,
    date: moment(),
    supplier: null,
    remarks: "",
    items: [],

    total_amount: 0,
    total_advance_payment: 0,
    total_creditable_advance_payment: 0,
    total_credit_advance_payment: 0,
  };

  const [state, setState] = useState(initialValues);
  const [date, setDate] = useState(null);

  const params = useParams();

  useEffect(() => {
    window.addEventListener("afterprint", (event) => {
      axios
        .post(`${url}${params.id}/print-status`, {
          user: auth.user,
        })
        .then((response) => {
          edit({
            record: { _id: response.data._id },
            setState,
            url,
            date_fields,
          });
        });
    });

    getDateTimeNow()
      .then((date) => setDate(date))
      .catch((err) =>
        message.error("There was an error getting curent date/time")
      );

    edit({
      record: { _id: params.id },
      setState,
      url,
      date_fields,
    });

    return () => {};
  }, []);

  return (
    <Content
      className={classnames("inventory-print print", {
        "m-t-4": duplicate,
      })}
    >
      <div>
        <Row>
          <Col span={24}>
            <ReportHeading has_logo={true} has_business_name={true} />
          </Col>
        </Row>

        <div className="has-text-centered is-size-5">{title}</div>
        <Row className="m-t-1">
          <Col span={4} className="is-flex align-items-flex-end">
            Date:
          </Col>
          <Col span={8} className="is-flex align-items-flex-end">
            {moment(state.date).format("ll")}
          </Col>
          <Col span={4} className="is-flex align-items-flex-end">
            PRQ#:
          </Col>
          <Col span={8} className="is-flex align-items-flex-end">
            <span className="ref-number">{state.prq_no}</span>
          </Col>
        </Row>
        <Row>
          <Col key="label" span={4}>
            Project:
          </Col>
          <Col key="value" span={8} className="report-customer-name">
            {state.project?.name?.toUpperCase()}
          </Col>
          <Col key="label" span={4}>
            Account:
          </Col>
          <Col key="value" span={8}>
            {state.project?.account?.name?.toUpperCase()}
          </Col>
        </Row>

        <Row>
          <Col span={4}>Remarks</Col>
          <Col span={8} className="pre-wrap">
            {state.remarks?.toUpperCase()}
          </Col>
          <Col span={4}>Printed:</Col>
          <Col span={8}>{date && moment(date).format("lll")}</Col>
        </Row>
      </div>

      <div className="m-t-1">
        <Table
          size="small"
          dataSource={addKeysToArray([
            ...(state.items || []),
            {
              footer: 1,

              case_quantity: sumBy(state.items, (o) => round(o.case_quantity)),
              quantity: sumBy(state.items, (o) => round(o.quantity)),

              amount: sumBy(state.items, (o) => round(o.amount)),
            },
          ])}
          columns={records_column}
          rowKey={(item) => item._id}
          pagination={false}
          rowClassName={(record, index) => {
            if (record.footer === 1) {
              return "footer-summary has-text-weight-bold";
            }
          }}
        />
      </div>

      <div className="signatories-container">
        <Row gutter={48}>
          <Col span={8}>Prepared by</Col>
          <Col span={8}>Checked by</Col>
          <Col span={8}>Approved by</Col>
        </Row>
        <Row gutter={48}>
          <Col span={8}>
            <div className="signatory">{state.logs?.[0]?.user?.name}</div>
          </Col>
          <Col span={8} className="has-text-centered">
            <div className="signatory">&nbsp;</div>
          </Col>
          <Col span={8}>
            <div className="signatory">&nbsp;</div>
          </Col>
        </Row>
      </div>
    </Content>
  );
}
